/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, DropdownButton, MenuItem, Row, Col, Glyphicon } from 'react-bootstrap';
import _ from 'underscore';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
class AddContactModal extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            name: "",
            phone: "",
            email: "",
        };
        this.handleChange = (field) => (e) => {
            this.setState({ [field]: e.target.value });
        };
        this.onSubmit = () => {
            this.props.addContact(this.state);
        };
    }
    render() {
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onHide() },
            React.createElement(Modal.Header, null,
                React.createElement(Modal.Title, null, t('ADD_CONTACT'))),
            React.createElement(Modal.Body, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 4 },
                        React.createElement("input", { placeholder: "Name", className: "w-full mb-4 block form-field", onChange: this.handleChange('name') })),
                    React.createElement(Col, { xs: 4 },
                        React.createElement("input", { placeholder: "Phone", className: "w-full mb-4 block form-field", onChange: this.handleChange('phone') })),
                    React.createElement(Col, { xs: 4 },
                        React.createElement("input", { placeholder: "Email", className: "w-full mb-4 block form-field", onChange: this.handleChange('email') })))),
            React.createElement(Modal.Footer, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 8 }),
                    React.createElement(Col, { xs: 2 },
                        React.createElement("button", { className: "button button-green", disabled: !this.state.name.length, onClick: this.onSubmit }, t('SUBMIT'))),
                    React.createElement(Col, { xs: 2 },
                        React.createElement("button", { className: "block button secondary-action", onClick: () => this.props.onClose() }, t('CANCEL')))))));
    }
}
export default withTranslation()(AddContactModal);
